/**
 * manualDecisionsApi.ts - decisions manuelles persistees par client.
 * Une fois EM-002 marque conforme manuellement, il reste conforme pour les
 * scans suivants jusqu a revocation explicite.
 */
import { apiFetch } from './apiClient';

export type ManualDecisionValue = 'conforme' | 'fail' | 'skip' | 'pending';

export interface ManualDecision {
  controlId: string;
  decision:  ManualDecisionValue;
  evidence?: string;
  decidedBy?: string;
  decidedAt?: string;
}

export interface ManualDecisionsResponse {
  /** Map controlId -> decision. */
  decisions: Record<string, ManualDecision>;
  updatedAt?: string;
  updatedBy?: string;
}

export const manualDecisionsApi = {
  list: () => apiFetch<ManualDecisionsResponse>('/clients/manual-decisions'),
  upsert: (input: { controlId: string; decision: ManualDecisionValue; evidence?: string }) =>
    apiFetch<ManualDecision>('/clients/manual-decisions', {
      method: 'POST',
      body:   JSON.stringify(input),
      headers: { 'Content-Type': 'application/json' },
    }),
  /** Revoque une decision (la passe en 'pending', retire du map). */
  revoke: (controlId: string) =>
    apiFetch<ManualDecision>('/clients/manual-decisions', {
      method: 'POST',
      body:   JSON.stringify({ controlId, decision: 'pending' }),
      headers: { 'Content-Type': 'application/json' },
    }),
};
